<template>
    <section class="bg-paymentBlue" style="min-height: 100vh !important">
        <!-- <div class="modal-mask"> -->
            <TopAppBarDrawer></TopAppBarDrawer>
            <main class="main-wrapper flex-grow-1  pdb-50 h-full">
				<div class="d-flex align-items-center ">
                    <div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 fix-header-title d-flex align-items-center justify-content-center">
                        <div class="font-m">{{$t('1021')}}</div>
                    </div>
				</div>
				<div class="divider"></div>
				<!-- subtabs -->
                <div class="container container--narrow mgt-50">
                    <div class="bg-white mgt-40">
                        <div class="headerRoll position-relative ">
                            <div class="bg-white position-relative h-29 z-99">
                                <div class="header-shadow"></div>
                            </div>
                        </div>
                    </div>
                    <div class="pdl-24 pdr-24 receipt-wrapper position-relative bg-white pdb-20">
                        <!-- 차수 이름 스킬패스/온라인클래스 -->
                        <div class="pdt-28 t-body3 t-line-h-24 l-spacing42 font-r 1"> {{orderCategory}}</div>

                        <div class="mgt-4 t-headline7 l-spacing6 font-m t-line-h-26">
                            {{goodsName}}
                        </div>
                        <div class="divider mgt-32 h-1 mgb-16 bg-payment-divider"></div>
                        <div class="pdt-11 pdb-11" v-if="['REQUEST_PAY', 'PAID', 'PAID_FREE','CANCEL_PAY'].indexOf(orderStatus) >= 0">
                            
                            <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 2">{{$t('1022')}}</div>
                            <div class="t-body1 mgt-4 t-line-h-22 font-r">{{$moment(learningStartDatetime).format('L')}} ~ {{learningEndDatetime}}</div>
                        </div>

                        <div class="pdt-11 pdb-11" v-if="['PAID_FREE'].indexOf(orderStatus) >= 0">
                            <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 3"  v-if="['PAID_FREE'].indexOf(orderStatus) >= 0">{{$t('486')}}</div>
                            <div class="t-body1 mgt-4 t-line-h-22 font-r l-spacing48"  v-if="['PAID_FREE'].indexOf(orderStatus) >= 0">{{$t(orderStatusTranslate)}}</div>
                            
                        </div>

                        <div class="pdt-11 pdb-11" v-if="['PAID'].indexOf(orderStatus) >= 0 && paymentPrice==0 && paymentMethod =='ESSENTIAL'">
                            <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 4"   v-if="['PAID'].indexOf(orderStatus) >= 0 && paymentPrice==0 && paymentMethod =='ESSENTIAL'">{{$t('486')}}</div>
                            <div class="t-body1 mgt-4 t-line-h-22 font-r"  v-if="['PAID'].indexOf(orderStatus) >= 0 && paymentPrice==0 && paymentMethod =='ESSENTIAL'">{{$t(orderStatusTranslate)}}</div>
                        </div>

                        <div class="divider_dot mgt-8 mgb-8" v-if="['PAID'].indexOf(orderStatus) >= 0 && (paymentMethod !=='paypal' && paymentMethod !=='bank_transfer') && paymentPrice>0"></div>
                        <div class="pdt-11 pdb-11" v-if="['PAID'].indexOf(orderStatus) >= 0 && paymentPrice>0" >
                            <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 5">{{$t('1043')}}</div>
                            <div class="t-body1 mgt-4 t-line-h-22 font-r">{{paidDate?$moment(paidDate).format('L'):''}}</div>
                        </div>

						<div class="divider_dot mgt-8 mgb-8" v-if="['REQUEST_PAY', 'PAID', 'CANCEL_PAY'].indexOf(orderStatus) >= 0"></div>

                        <div  v-if="['REQUEST_PAY', 'PAID', 'CANCEL_PAY'].indexOf(orderStatus) >= 0">
                            
                            <div class="pdt-11 pdb-11" v-if="['REQUEST_PAY','CANCEL_PAY'].indexOf(orderStatus) >= 0">
                                <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 6">{{$t('1023')}}</div>
                                <div class="mgt-4 ">
                                    <span class="t-body1 font-r  t-line-h-22 pdr-5 7">{{currency}}</span>
                                    <span class="t-body1 t-color-saleLine font-r t-line-h-24">{{$n(paymentPrice)}}</span>
                                </div>
                            </div>

                            <div class="pdt-11 pdb-11" v-if="['PAID'].indexOf(orderStatus) >= 0 && paymentPrice>0">
                                <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 8">{{$t('1044')}}</div>
                                <div class="mgt-4 ">
                                    <span class="t-body1 font-r  t-line-h-22 pdr-5">{{currency}}</span>
                                    <span class="t-body1 t-color-saleLine font-r t-line-h-24">{{$n(paymentPrice)}}</span>
                                </div>
                            </div>

                            <div class="pdt-11 pdb-11" v-if="totalPrice>0">
                                <div class="t-body1 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA" v-if="totalPrice>0">{{$t('1024')}}</div>
                                <div class="mgt-4 " v-if="totalPrice>0">
                                    <span class="t-body1 font-r  t-line-h-22 pdr-5 9">{{currency}}</span>
                                    <span class="t-body1 font-r t-line-h-24">{{$n(totalPrice)}}</span>
                                </div>
                            </div>
                            
                            <div class="pdt-11 pdb-11" v-if="discountPrice>0">
                                <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA" v-if="discountPrice>0">{{$t('1025')}}</div>
                                <div class="mgt-4" v-if="discountPrice>0">
                                    <span class="t-body1 font-r  t-line-h-22 pdr-5 10">{{currency}}</span>
                                    <span class="t-body1 font-r t-line-h-24">-{{$n(discountPrice)}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="divider_dot mgt-8 mgb-8" v-if="['REQUEST_PAY', 'PAID','CANCEL_PAY'].indexOf(orderStatus) >= 0 && paymentPrice >0 && paymentMethod !=='ESSENTIAL'"></div>
                            <div v-if="['REQUEST_PAY', 'PAID','CANCEL_PAY'].indexOf(orderStatus) >= 0 && paymentPrice >0 && paymentMethod !=='ESSENTIAL'">
                                <div  class="pdt-11 pdb-11">
                                    <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 11">{{$t('1026')}}</div>
                                    <div class="mgt-4 " v-if="paymentMethod=='paypal'">
                                        <span class="t-body1 font-r t-line-h-24">{{$t('3413')}}</span>
                                    </div>
                                    <div class="mgt-4 " v-else-if="paymentMethod=='bank_transfer'">
                                        <span class="t-body1 font-r t-line-h-24">{{$t('3414')}}</span>
                                    </div>
                                    <div class="mgt-4 " v-else>
                                        <span class="t-body1 font-r t-line-h-24">{{printPaymentMethod}}</span>
                                    </div>

                                </div>
                                
                                <div class="pdt-11 pdb-11">
                                    <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA">{{$t('1027')}}</div>
                                    <div class="mgt-4 ">
                                        <span class="t-body1 font-r  t-line-h-22 pdr-5 12" v-if="orderStatusTranslate=='code.order.list.statusREFUNDED_FREE.paid'">{{$t('3403')}}</span>
                                        <span class="t-body1 font-r t-line-h-24" v-else>{{$t(orderStatusTranslate)}}</span>
                                    </div>
                                </div>

                            </div>
                        <div  v-if="['REQUEST_PAY','CANCEL_PAY'].indexOf(orderStatus) >= 0 && paymentMethod === 'bank_transfer'">
                        <div class="divider_dot mgt-8 mgb-8"></div>
                            <!-- <div class="divider_dot mgb-16"></div> -->
                            <div class="pdt-11 pdb-11">
                                <div class="t-body1 t-line-h-26 font-r l-spacing48">
                                    {{$t('1028')}} <br>
                                    {{$t('1029')}}
                                </div>
                            </div>
                                <div class="pdt-11 pdb-11" v-if="bankName && bankNumber">
                                    <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA">{{$t('1030')}}</div>
                                    <div class="mgt-4 ">
                                        <span class="t-body1 font-r  t-line-h-22 pdr-5 13">{{bankName}}</span>
                                        <span class="t-body1 font-r t-line-h-24">{{bankNumber}}</span>
                                    </div>
                                </div>

                                <div class="pdt-11 pdb-11" v-if="bankDepositName">
                                    <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 14">{{$t('1031')}}</div>
                                    <div class="mgt-4 ">
                                        <span class="t-body1 font-r t-line-h-24">{{bankDepositName}}</span>
                                    </div>
                                </div>

                                <div class="pdt-11 pdb-11" v-if="paymentPrice">
                                    <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 15">{{$t('1032')}}</div>
                                    <div class="mgt-4 ">
                                        <span class="t-body1 font-r  t-line-h-22 pdr-5 16">{{currency}}</span>
                                        <span class="t-body1 t-color-saleLine font-r t-line-h-24 t-color-mainBtn">{{$n(paymentPrice)}}</span>
                                    </div>
                                </div>

                                <div class="pdt-11 pdb-11" v-if="deadline">
                                    <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 17">{{$t('1033')}}</div>
                                    <div class="mgt-4">
                                        <span class="t-body1 pdb-24  font-r t-line-h-24">{{$moment(deadline).format('L')}} {{$moment(deadline).format('LT')}}</span>
                                        <!-- <span class="t-body1 pdb-24  font-r t-line-h-24">{{$moment(deadline).format('lll')}}</span> -->
                                    </div>
                                </div>
                            
                        </div>


                        <div  v-if="['REQUEST_REFUND', 'REFUNDING', 'REJECT_REFUND','REFUNDED','FAIL_REFUND'].indexOf(orderStatus) >= 0">
                              <!-- <div class="divider_dot mgt-8 mgb-8"></div> -->
                            <div class="pdt-11 pdb-11" v-if="refundCode">   
                                <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 18">{{$t('1148')}}</div>
                                <div class="mgt-4" v-if="refundCode">
                                    <span class="t-body1 font-r t-line-h-24">{{refundCode}}</span>
                                </div>
                            </div>

                            <div class="pdt-11 pdb-11">
                                <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 19">{{$t('1149')}}</div>
                                <div class="mgt-4 ">
                                    <span class="t-body1 font-r t-line-h-24 t-color-mainBtn">{{$t(orderStatusTranslate)}}</span>
                                </div>
                            </div>

                            <div class="pdt-11 pdb-11">
                                <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 20">{{$t('1150')}}</div>
                                <div class="mgt-4 ">
                                    <span class="t-body1 font-r t-line-h-24">{{refundRequestReason}}</span>
                                </div>
                            </div>

                            <div class="pdt-11 pdb-11">
                                <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 21">{{$t('1151')}}</div>
                                <div class="mgt-4">
                                    <span class="t-body1 font-r t-line-h-24">{{refundAccount.bank.text}}</span>
                                    <span class="t-body1 font-r t-line-h-24">{{refundAccount.number}}</span>
                                    <span class="t-body1 font-r t-line-h-24">{{refundAccount.name}}</span>
                                </div>
                            </div>

                            <div class="pdt-11 pdb-11">
                                <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA 22">{{$t('1152')}}</div>
                                <div class="mgt-4 ">
                                    <span class="t-body1 font-r t-line-h-24">{{$moment(refundRequest).format('L')}}</span>
                                </div>
                             </div>

                            <div v-if="['REQUEST_REFUND'].indexOf(orderStatus) >= 0">
                                <div class="divider_dot mgt-8 mgb-8"></div>
                                <div class="pdt-11 pdb-11" v-if="paymentPrice">
                                    <div class="t-body3 pdt-23  font-r l-spacing42 t-line-h-22 t-color-bodyGrayA">{{$t('1153')}}</div>
                                    <div class="mgt-4">
                                        <span class="t-body1 font-r  t-line-h-22 pdr-5">{{currency}}</span>
                                        <span class="t-body1 font-r t-line-h-24 t-color-mainBtn">{{$n(paymentPrice)}}</span>
                                    </div>
                                </div>
                            </div>

                            <div v-if="['REFUNDED'].indexOf(orderStatus) >= 0">
                                <!-- <div class="divider_dot mgb-16"></div> -->
                                <div class="pdt-11 pdb-11" v-if="refundAmountValue">
                                    <div class="t-body3 font-r l-spacing42 t-line-h-22 t-color-bodyGrayA">{{$t('1172')}}</div>
                                    <div class="mgt-4">
                                        <span class="t-body1 font-r  t-line-h-22 pdr-5">{{refundAmountCurrency}}</span>
                                        <span class="t-body1 font-r t-line-h-24 t-color-mainBtn" > {{$n(refundAmountValue)}}</span>
                                    </div>
                                </div>

                                <div class="pdt-11 pdb-11"  v-if="refundApproved">
                                    <div class="t-body3 pdt-24  font-r l-spacing42 t-line-h-22 t-color-bodyGrayA">{{$t('1173')}}</div>
                                    <div class="mgt-4 ">
                                        <span class="t-body1 font-r t-line-h-24">{{refundApproved?$moment(refundApproved).format('L'):''}}</span>
                                    </div>
                                </div>
                            </div>

                            <div v-if="['REJECT_REFUND'].indexOf(orderStatus) >= 0">
                                <div class="divider_dot mgt-8 mgb-8"></div>
                                <div class="pdt-11 pdb-11" v-if="refundRejectReason">
                                    <div class="t-body3 pdt-12  font-r l-spacing42 t-line-h-22 t-color-bodyGrayA">{{$t('1180')}}</div>
                                    <div class="mgt-4 ">
                                        <span class="t-body1 font-r t-line-h-24">{{refundRejectReason}}</span>
                                    </div>
                                </div>

                                <div class="pdt-11 pdb-11" v-if="refundReject">
                                    <div class="t-body3 pdt-24  font-r l-spacing42 t-line-h-22 t-color-bodyGrayA 23">{{$t('1181')}}</div>
                                    <div class="mgt-4 ">
                                        <span class="t-body1 font-r t-line-h-24">{{refundReject?$moment(refundReject).format('L'):''}}</span>
                                    </div>
                                </div>
                            </div>

                            <div v-if="['REFUNDING'].indexOf(orderStatus) >= 0">
                                <div class="divider_dot mgt-8 mgb-8"></div>
                                <div class="pdt-11 pdb-11" v-if="refundAmountCurrency">
                                    <div class="t-body3 font-r l-spacing42 t-line-h-22 t-color-bodyGrayA 24">{{$t('1162')}}</div>
                                    <div class="mgt-4 ">
                                        <span class="t-body1 font-r  t-line-h-22 pdr-5 25">{{refundAmountCurrency}}</span>
                                        <span class="t-body1 font-r t-line-h-24 t-color-mainBtn"> {{$n(refundAmountValue)}}</span>
                                    </div>
                                </div>

                                <div class="pdt-11 pdb-11" v-if="refundApproved">
                                    <div class="t-body3 pdt-24  font-r l-spacing42 t-line-h-22 t-color-bodyGrayA 26">{{$t('1163')}}</div>
                                    <div class="mgt-4 ">
                                        <span class="t-body1 font-r t-line-h-24">{{refundApproved?$moment(refundApproved).format('L'):''}}</span>
                                    </div>
                                </div>
                            </div>
                            
                        </div>                                 
                                                    
                    </div>                           
					<div class="receipt-wrapper-bottom h-20"></div>
                    <div class="">
                        <!-- <div class="mgt-16 mgb-16" v-if="['PAID','REQUEST_PAY'].indexOf(orderStatus) >= 0"> -->
                        <div class="mgt-24 mgb-8" v-if="['PAID'].indexOf(orderStatus) >= 0 && paymentPrice>0">
                            <div class="t-subtitle5 font-m l-spacing54 t-line-h-24">
                                {{$t('1122')}}
                                <!-- 학습 중도 포기에 대한 안내 -->
                            </div>
                            <div class="t-body3 mgb-50 t-color-bodyGrayA t-line-h-24 l-spacing42 font-r mgt-8">
                               
                                    {{$t('1123')}}<br>
                                    {{$t('1124')}}<br>
                                    {{$t('1125')}}
                                    <!-- 
                                        학습 중단을 원하는 경우, 상품 환불 요청을 할 수 있습니다.
                                        환불 요청 직후부터 해당 상품은 더이상 학습이 불가함을 알려드립니다.
                                        관리자가 환불 요청 내용을 승인 시 환불이 처리되며, 환불 금액은 관리자에 의해 책정됩니다.
                                        -->
                               
                            </div>
                        </div>

                        <!-- <div class="mgt-16 mgb-16" v-if="['PAID_FREE'].indexOf(orderStatus) >= 0"> -->
                        <div class="mgt-24 mgb-8" v-if="['PAID_FREE'].indexOf(orderStatus) >= 0  && paymentMethod !=='FREE'">
                            <div class="t-subtitle5 font-m l-spacing54 t-line-h-24">
                                {{$t('1122')}}
                                <!-- 학습 중도 포기에 대한 안내 -->
                            </div>
                            <div class="t-body3 mgt-8 t-color-bodyGrayA t-line-h-22 l-spacing42 font-r">
                                    {{$t('488')}}<br>
                                    {{$t('489')}}
                                    <!-- 
                                        학습 중단을 원하는 경우, 신청을 취소할 수 있습니다.
                                        신청 취소 직후부터 해당 상품은 더 이상 학습이 불가함을 알려드립니다.
                                        -->
                                
                            </div>
                        </div>

                        <div class="mgt-24 mgb-8" v-if="['PAID_FREE'].indexOf(orderStatus) >= 0  && (paymentMethod =='FREE' || paymentPrice == 0)">
                            <div class="t-subtitle5 font-m l-spacing54 t-line-h-24">
                                {{$t('1122')}}
                                <!-- 학습 중도 포기에 대한 안내 -->
                            </div>
                            <div class="t-body3 mgt-8 t-color-bodyGrayA t-line-h-22 l-spacing42 font-r">
                                    {{$t('488')}}<br>
                                    {{$t('489')}}
                                    <!-- 
                                        학습 중단을 원하는 경우, 신청을 취소할 수 있습니다.
                                        신청 취소 직후부터 해당 상품은 더 이상 학습이 불가함을 알려드립니다.
                                        -->
                                
                            </div>
                        </div>

                        <div class="mgt-16 mgb-16" v-if="['REFUNDING'].indexOf(orderStatus) >= 0">
                            <div class="t-body3 t-color-bodyGrayA t-line-h-22 l-spacing42 font-r">
                                
                                    {{$t('1164')}}
                                    
                                    <!-- 
                                        환불이 완료되기까지 약 14일이 소요될 수 있습니다.
                                        -->
                                
                            </div>
                        </div>

                        <div class="mgt-24 mgb-16" v-if="['FAIL_REFUND'].indexOf(orderStatus) >= 0">
                            <div class="t-subtitle5 font-m l-spacing54 t-line-h-24">
                                {{$t('1189')}}
                                <!-- 환불이 승인되었으나 보류 상태입니다 -->
                            </div>
                            <div class="font-r t-body3 mgt-8 t-color-bodyGrayA t-line-h-22 l-spacing42">
                                
                                    {{$t('1190')}}<br>
                                    {{$t('1191')}}
                                    <!-- 
                                        회원님의 환불 요청이 승인되었으나, 결제사의 문제로 환불 
                                        처리가 보류되었습니다.
                                        관리자가 환불 금액을 직접 송금할 계좌 정보를 입력해주세
                                        요.
                                        -->
                                
                            </div>
                        </div>
                        
                    </div>
                        <div class="mgt-50">
                            <button class="mdc-button t-color-secondaryBtnText b-radius4" tabindex="0" @click="moveQnA(paymentMethod)" @keypress="moveQnA(paymentMethod)" v-if="['REQUEST_REFUND','REFUNDING','REJECT_REFUND','FAIL_REFUND','REFUNDED'].indexOf(orderStatus) >= 0">
                                <div class="mdc-button__ripple"></div>
                                <span class="mdc-button__label t-body2 font-r">{{$t('1154')}}</span>
                                <!-- 1:1 문의하기 -->
                            </button>

                            <button class="mdc-button t-color-mainBtn b-radius4 mgr-8" tabindex="0" @click="requestRefund(paymentMethod)" @keypress="requestRefund(paymentMethod)" v-if="['PAID'].indexOf(orderStatus) >= 0  && paymentPrice>0 && paymentMethod !=='ESSENTIAL'">
                                <div class="mdc-button__ripple"></div>
                                <span class="mdc-button__label t-body2 font-r">{{$t('1126')}}</span>
                            </button>

                            <button class="mdc-button t-color-mainBtn b-radius4 mgr-8" tabindex="0" @click="requestRefund(paymentMethod)" @keypress="requestRefund(paymentMethod)" v-if="['FAIL_REFUND'].indexOf(orderStatus) >= 0">
                                <div class="mdc-button__ripple"></div>
                                <span class="mdc-button__label t-body2 font-r">{{$t('1192')}}</span>
                            </button>

                            <button class="mdc-button t-color-secondaryBtnText b-radius4" tabindex="0" @click="requestRefund(paymentMethod)" @keypress="requestRefund(paymentMethod)"  v-if="['REQUEST_REFUND', 'REFUNDING','FAIL_REFUND'].indexOf(orderStatus) >= 0">
                                <div class="mdc-button__ripple"></div>
                                <span class="mdc-button__label t-body2 font-r">{{$t('1155')}}</span>
                                <!-- 환불 정보 수정 -->
                            </button>

                            <button class="mdc-button t-color-mainBtn b-radius4 mgr-8" tabindex="0" @click="cancelEnrollment()" @keypress="cancelEnrollment()" v-if="['PAID_FREE'].indexOf(orderStatus) >= 0 && paymentMethod !=='FREE' && paymentMethod !=='ESSENTIAL'">
                                <div class="mdc-button__ripple"></div>
                                <span class="mdc-button__label t-body2 font-r">{{$t('490')}}</span>
                                <!-- 등록 취소하기 -->
                            </button>

                            <button class="mdc-button t-color-mainBtn b-radius4 mgr-8" tabindex="0" @click="cancelEnrollment()" @keypress="cancelEnrollment()" v-if="['PAID_FREE'].indexOf(orderStatus) >= 0 && (paymentMethod =='FREE' || paymentPrice ==0 )">
                                <div class="mdc-button__ripple"></div>
                                <span class="mdc-button__label t-body2 font-r">{{$t('490')}}</span>
                                <!-- 등록 취소하기 -->
                            </button>

                            <button class="mdc-button t-color-mainBtn b-radius4 mgr-8" tabindex="0" @click="cancelPurchase()" @keypress="cancelPurchase()" v-if="['REQUEST_PAY'].indexOf(orderStatus) >= 0">
                                <div class="mdc-button__ripple"></div>
                                <span class="mdc-button__label t-body2 font-r">{{$t('1035')}}</span>
                                <!-- 구매 취소하기 -->
                            </button>

                            <!-- <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" @click="movePurchaseList()">
                                <div class="mdc-button__ripple"></div>
                                <span class="mdc-button__label t-body2 font-r">{{$t('978')}}</span>
                            </button>
                            <button class="mdc-button mdc-button--raised bg-secondaryBtn t-color-secondaryBtnText b-radius4" @click="moveList()">
                                <div class="mdc-button__ripple"></div>
                                <span class="mdc-button__label t-body2 font-r">{{$t('979')}}</span>
                            </button> -->
                        </div>
					</div>
					<!-- <div class="mgt-100"></div> -->
	        </main>
        <!-- </div> -->
    </section>
</template>

<script>

// CREATED_ORDER(1, "주문 생성", "code.order.list.status.created.order") : 주문생성
// REQUEST_PAY(2, "결제 요청", "code.order.list.status.request.pay") : 결제대기
// CANCEL_PAY(3, "결제 취소", "code.order.list.status.cancel.pay") : 결제취소
// PAID(4, "결제 완료", "code.order.list.status.paid") : 결제완료
// REQUEST_REFUND(5, "환불 요청", "code.order.list.status.request.refund") : 환불요청
// REFUNDING(6, "환불 처리", "code.order.list.status.refunding") : 환불처리중
// REJECT_REFUND(7, "환불 반려", "code.order.list.status.reject.refund") : 환불반려
// REFUNDED(8, "환불 완료", "code.order.list.status.refunded") : 환불완료
// FAIL_REFUND(9, "환불 보류", "code.order.list.status.fail.refund") : 환불보류
// PAID_FREE(20, "무료 결제", "code.order.list.status.paid.free") : 신청완료
// REFUNDED_FREE(21, "무료 결제 환불", "code.order.list.status.refunded.free") : 신청취소
// UNKNOWN(9999, "알수없는 상태", "code.order.list.status.unknown") : 알수 없는 상태

/**
 * 멤버십 - 구매 상세 컴포넌트(membership - purchase view component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCDialog} from '@material/dialog';

import learnApi from '@/api/learnApi.js'
import salesApi from '@/api/salesApi.js'
import {commonMixin} from '@/mixins/common.js'
import {MDCRipple} from '@material/ripple'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import { utilDateMixin } from '@/mixins/dateUtil';

export default {
    data() {
        return {
            orderId: null,
            orderCategory: '',
            goodsName: '',
            learningEndDatetime: '',
            learningStartDatetime: '',
            paymentPrice: '',
            totalPrice: '',
            discountPrice: '',
            currency: '',
            bankName: '',
            bankNumber: '',
            bankDepositName: '',
            deadline: '',
            paidDate: 0,
            learnerId: '',

            orderStatus: '',
            orderStatusTranslate: '',
            paymentMethod: '',
            depositAccount: {},

            refundDialog: null,

            bankList: [],
            refundStatus: null,

            refundAccount: '',
            refundApproved: '',
            refundCanceled: '',

            refundAmountCurrency: '',
            refundAmountValue: '',

            refundCode: '',
            refundReject: '',
            refundRejectReason: '',
            refundRequest: '',
            refundRequestReason: '',
            refundReject: '',


        }
    },

    components: {
        TopAppBarDrawer
    },

    mixins: [commonMixin, utilDateMixin],
    mounted() {
        // console.log('document=>innerHeight',document.getElementById('getId').clientHeight)
		// console.log('document=>outerHeight',document.getElementById('getId').offsetHeight)
		// console.log('screen=>height',document.getElementById('getId').scrollHeight)
        this.orderId = this.$route.params.orderId
        this.fatchData()
        
    },

    computed: {
        isBeforeBankTransfer() {
            return this.orderStatus === 'REQUEST_PAY' && this.paymentMethod === 'bank_transfer'
        },

        isPaid() {
            return this.orderStatus === 'PAID'
        },

        isOrderFree() {
            return this.paymentMethod === 'FREE'
        },

        isRefund() {
            return !!this.refundStatus
        },

        // set payment method text
        printPaymentMethod() {
            switch (this.paymentMethod) {
                case 'paypal':
                    return 'PayPal'
                    break;
                case 'bank_transfer':
                    return 'Bank Transfer'
                    break;
                case 'dummy':
                    return 'Dummy'
                    break;
                case 'credit_card':
                    return 'Credit Card'
                    break;
                case 'FREE':
                    return 'Free'
                    break;
                default:
                    break;
            }
        }

    },

    methods: {
        fatchData() {
            let params = {
                orderId: this.$route.params.orderId
            }
            
            // get sales order information
            salesApi.salesOrderDetail(params).then((response) => {
                let orderData = response.data.data

                if(orderData.category.key === "EXAM") this.orderCategory = this.$t("3401");
                if(orderData.category.key === "MICRO_ONLINE") this.orderCategory = this.$t("30236");
                if(orderData.category.key === "ONLINE") this.orderCategory = this.$t("3400");

                this.goodsName = orderData.goods.name

                let learningEndTime = Number(orderData.goods.information.learningEndDatetime || orderData.goods.information.postEndDatetime)
                this.learningEndDatetime = this.displayEndPeriod(learningEndTime);
                this.learningStartDatetime = Number(orderData.goods.information.learningStartDatetime || orderData.goods.information.postStartDatetime)

                this.deadline = Number(orderData.deadline)
                this.paymentPrice = orderData.paymentPrice
                this.totalPrice = orderData.totalPrice
                this.discountPrice = orderData.discountPrice
                this.currency = orderData.currency

                this.paidDate = orderData.paidDate
                
                this.orderStatus = orderData.status.value
                this.orderStatusTranslate = orderData.status.translate

                
                // this.orderStatus = ''
                this.paymentMethod = orderData.paymentMethod
                localStorage.setItem('paymentMethod',this.paymentMethod)
                this.depositAccount = orderData.depositAccount
                if (orderData.paymentMethod === 'bank_transfer' && this.depositAccount) {
                    this.bankName = orderData.depositAccount.bank.text
                    this.bankNumber = orderData.depositAccount.number
                    this.bankDepositName = orderData.depositAccount.name
                }else {
                    //this.learnerId = orderData.paidData.learnerId
                }

                if (orderData.paidData) {
                    this.learnerId = orderData.paidData.learnerId
                }

                this.refundStatus = orderData.refundStatus

                this.refundAccount = orderData.refundAccount
                this.refundApproved = orderData.refundApproved
                this.refundCanceled = orderData.refundCanceled

                if (orderData.refundAmount) {
                    this.refundAmountCurrency = orderData.refundAmount.currency
                    this.refundAmountValue = orderData.refundAmount.value
                }
                

                this.refundCode = orderData.refundCode
                this.refundReject = orderData.refundReject
                this.refundRejectReason = orderData.refundRejectReason
                this.refundRequest = orderData.refundRequest
                this.refundRequestReason = orderData.refundRequestReason
                this.refundReject = orderData.refundReject


                this.$parent.setTopAppBarCustom({
                    leftBtnMode: 'arrow_back',
                    rightBtnMode: '',
                    title: localStorage.getItem('brandName'), //'구매내역',
                    leftBtnMethod: () => {
                        this.$router.go(-1)
                    },
                    rightBtnMethod: '',
                })
            }).catch((err) => {

            })
            
        },

        // call refund request popup
        requestRefund(paymentMethod) {
            
            let alertData = {
                title: this.$t('1127'), //환불 요청하시겠습니까?
                content: this.$t('1128') + ' ' + this.$t('1129') , //'환불 요청 시 학습은 불가능하며, 관리자 승인 후 환불이 처리됩니다.
                accept: this.$t('1131'), //'확인',
                cancel: this.$t('1130'), //'취소'
            }
            this.$confirm(alertData).then(() => {
                this.requestPaypalRefund(paymentMethod)
            }).catch(() => {

            })
        },

        
        // cancel enrollment
        cancelEnrollment() {
            let alertData = {
                title: this.$t('491'), //신청을 취소하시겠습니까?
                content: this.$t('492') + ' ' + this.$t('493') , //신청 취소 시 학습이 더 이상 불가능합니다. 확인을 누르면 신청이 취소됩니다.
                accept: this.$t('495'), //'확인',
                cancel: this.$t('494'), //'취소'
            }
            this.$confirm(alertData).then(() => {
                this.requestCancelEnrollment()
            }).catch(() => {

            })
        },

        // cancel purchase
        cancelPurchase() {
            let alertData = {
                title: this.$t('1036'), //구매를 취소하시겠습니까?
                content: this.$t('1037') + ' ' + this.$t('1038') , //구매 취소는 결제 대기 상태인 경우만 가능합니다. 확인을 누르면 구매가 취소됩니다.
                accept: this.$t('1040'), //'확인',
                cancel: this.$t('1039'), //'취소'
            }
            this.$confirm(alertData).then(() => {
                // this.requestPaypalRefund()
                this.requestCancelPurchase()
            }).catch(() => {

            })
        },
        
        // request cancel enrollment
        requestCancelEnrollment() {
            // let params = {
            //     orderId: this.orderId,
            // }

            // salesApi.selesRequestRefund(params).then((response) => {
            //     this.$router.go(-1)
            // })

            this.$router.push({
                name: 'MemberPurchaseRefund',
                params: {
                    orderId: this.orderId
                }
            })
            
        },

        // request cancel purchase
        requestCancelPurchase() {
            let params = {
                orderId: this.orderId,
            }

            salesApi.selesRequestRefund(params).then((response) => {
                this.$router.go(-1)
            })
        },


        // move request refund 
        requestPaypalRefund(paymentMethod) {
            if(paymentMethod=='paypal' || paymentMethod=='FREE') {
                this.$router.push({
                    name: 'MemberPurchaseRefund',
                    params: {
                        orderId: this.orderId
                    }
                })
            } else {
                this.$router.push({
                    name: 'MemberPurchaseRefundBank',
                    params: {
                        orderId: this.orderId
                    }
                })
            }
            
        },

        moveQnA() {
            this.$router.push({
                name: 'MemberPurchaseQnA',
                params: {orderId: this.orderId}
            })
        }
    }
}
</script>